'use strict';

/**
 * Handle checkbox state for rewards
 */
function handleCheckboxState() {
    var removeRewardCheckbox = $('.checkbox_reward');
    var $noReward = $('.no_reward');
    removeRewardCheckbox.each(function () {
        $(this).prop('checked', false);
    });
    var $loyaltyCouponDetails = $('.loyaltyCouponDetails');
    if ($loyaltyCouponDetails.length) {
        $loyaltyCouponDetails.each(function () {
            var uuid = $(this).data('uuid');
            var isloyalty = $(this).data('isloyalty');
            var couponCode = $(this).data('code');
            var rewardCheckbox = $(
                `.checkbox_reward[data-rewardid=${couponCode}]`
            );
            rewardCheckbox.attr('data-uuid', uuid);
            rewardCheckbox.attr('data-isloyalty', isloyalty);
            rewardCheckbox.prop('checked', true);
        });
    } else if ($noReward.length) {
        $noReward.prop('checked', true);
    }
}

/**
 * Active available rewards response
 */
// eslint-disable-next-line
function rewardsResponse(data) {
    if (data.allActiveInactiveRewards && !$('#isantavoenabled').data('isantavoenabled')) {
        var onlyonerewardallowed = $('.available-rewards').data('onlyonerewardallowed');
        var activeRewards = data.allActiveInactiveRewards.activeRewards;
        var inActiveRewards = data.allActiveInactiveRewards.inActiveRewards;
        var allRewards = [];
        $('.available-rewards .page-error').remove();
        $('.rewards__detail .page-error').addClass('d-none');
        if ((activeRewards !== null && activeRewards !== undefined) || (inActiveRewards !== null && inActiveRewards !== undefined)) {
            if (activeRewards) {
                activeRewards.forEach(function (item) {
                    var activeRewardSection = $(
                        `.checkbox_reward[data-rewardid="${item.RewardId}"]`
                    ).closest('.reward-section');
                    allRewards.push(item.RewardId);
                    activeRewardSection.removeClass('disabled');
                    if (onlyonerewardallowed) {
                        activeRewardSection.find('.checkbox_reward').prop('disabled', false);
                    } else {
                        activeRewardSection.find('.form-check input[type="checkbox"]').removeAttr('disabled');
                    }
                });
            }

            if (inActiveRewards) {
                inActiveRewards.forEach(function (item) {
                    var inActiveRewardSection = $(
                        `.checkbox_reward[data-rewardid="${item.RewardId}"]`
                    ).closest('.reward-section');
                    allRewards.push(item.RewardId);
                    $('.reward-section').removeClass('d-none');
                    $('.show_more_rewards').addClass('d-none');
                    inActiveRewardSection.addClass('disabled');
                    $('.reward_unavailable_title').removeClass('d-none');
                    if (onlyonerewardallowed) {
                        inActiveRewardSection.find('.checkbox_reward').prop('disabled', true);
                    } else {
                        inActiveRewardSection.find('.form-check input[type="checkbox"]').attr('disabled', 'disabled');
                    }
                });
            }

            $('.reward-section').each(function () {
                var rewardId = $(this)
                    .find('.checkbox_reward')
                    .attr('data-rewardid');
                if (!allRewards.includes(rewardId) && !$(this).hasClass('no_reward_section') && !($(this).find('#deselectAllRewards').length > 0)) {
                    $(this).remove();
                }
                if ($(this).hasClass('disabled')) {
                    $(this).detach().appendTo('.available-rewards');
                } else {
                    $(this).detach().appendTo('.available-reward-section');
                }
                if ($('.reward-section.disabled').length === 0) {
                    $('.reward_unavailable_title').addClass('d-none');
                }
            });
            handleCheckboxState();
        } else {
            $('.reward-section').each(function () {
                $(this).remove();
            });

            if (!data.allActiveInactiveRewards.success && data.allActiveInactiveRewards.errorMessage) {
                if ($('.available-rewards').length) {
                    $('.available-rewards').remove();
                }
                if ($('.rewards__detail .page-error').length) {
                    $('.rewards__detail .page-error').removeClass('d-none');
                } else {
                    $('.rewards-points-payment').css('display', 'none');
                    var html = '<div class="page-error mb-0 mt-1" role="alert"><div><svg class="icon-utility-alert-red"><use xlink:href="#alert-red"></use></svg></div><div class="message">' + data.allActiveInactiveRewards.errorMessage + '</div></div>';
                    $('#registered-eligible-message').html(html);
                }
            }
        }
    }
}

/**
 * Handle rewrad limit message
 */
function handleRewardLimitState() {
    $('.rewardlimitmessagewrapper').addClass('hide');
    var rewardCap = $('.rewardlimitmessagewrapper').attr('data-rewardlimit');
    let rewardLmtMsg = $('.rewardlimitmessagewrapper').attr('data-rewardcapmsg');
    if ($('.reward-section .ds-checkbox input[type="checkbox"]:checked').length >= rewardCap && $('.cartRewardLimitMsg').length) {
        $('.cartrewardlimitmessage').text(rewardLmtMsg);
        $('.rewardlimitmessagewrapper').removeClass('hide');
    }
}

/**
 * Handle rewrad limit message
 */
function handleRewardLimitBreached() {
    $('.rewardlimitmessagewrapper').addClass('hide');
    var rewardCap = $('.rewardlimitmessagewrapper').attr('data-rewardlimit');
    if ($('.reward-section .ds-checkbox input[type="checkbox"]:checked').length > rewardCap && $('.cartRewardLimitMsg').length) {
        let reqMsg = $('.cartRewardLimitMsg').attr('value');
        $('.cartrewardlimitmessage').text(reqMsg);
        $('.rewardlimitmessagewrapper').removeClass('hide');
    }
}

$(document).ready(function () {
    var $rewardsDiv = $('.cart .antavo_rewards_section');
    var $targetDiv = $('#tablet-reward-placeholder'); // or any other target element

    /**
     * reorderRewards
     */
    function reorderRewards() {
        var width = $(window).width();
        var isPortrait = window.matchMedia('(orientation: portrait)').matches;

        if (width <= 992 && isPortrait) {
        // Cut and move to new position
            $rewardsDiv.detach().insertBefore($targetDiv);
        }
    }
    // Initial run
    reorderRewards();

    // On resize or orientation change
    $(window).on('resize orientationchange', function () {
        reorderRewards();
    });
});

export {
    handleCheckboxState,
    rewardsResponse,
    handleRewardLimitState,
    handleRewardLimitBreached
};
